import { useContext } from "react";
import SubGroupContext from "../context/SubGroupProvider";

const useSubGroup = () => {
    return useContext(SubGroupContext);
}

export default useSubGroup;